export const getTextFromHtml = (t?: string) => {
  // const [text, setText] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return typeof window !== 'undefined'
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      new DOMParser().parseFromString(t || '', 'text/html').documentElement.textContent!
    : t;
};
